<div class="admin-manage-form">
  <p class="TXT_TITLE">:: Admin Manage Request P&A ::</p>
  <div style="margin-bottom: 20px" class="formStyle">
    <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
      <div class="form-group">
        <label for="companyCode" class="textColor">Company Code:</label>
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select Company Code"
          formControlName="companyCode"
        >
          <nz-option
            *ngFor="let company of companies"
            nzLabel="{{ company.ccnCode }}"
            nzValue="{{ company.ccnCode }}"
          ></nz-option>
        </nz-select>
      </div>
      <div class="form-group">
        <label for="buyer" class="textColor">Buyer:</label>
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select Buyer"
          formControlName="buyer"
        >
          <nz-option
            *ngFor="let buyer of buyers"
            nzLabel="{{ buyer.fullName }}"
            nzValue="{{ buyer.userId }}"
          ></nz-option>
        </nz-select>
      </div>
      <div class="form-group">
        <label for="purchasingOffice" class="textColor"
          >Purchasing Office:</label
        >
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select Purchasing Office"
          formControlName="purchasingOffice"
        >
          <nz-option
            *ngFor="let office of purchasingOffices"
            nzLabel="{{ office.purchasingName }}"
            nzValue="{{ office.purchasingName }}"
          ></nz-option>
        </nz-select>
      </div>
      <div class="form-group">
        <label for="status" class="textColor">Status:</label>
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select Status"
          formControlName="status"
        >
          <nz-option
            *ngFor="let status of statuses"
            nzLabel="{{ status }}"
            nzValue="{{ status }}"
          ></nz-option>
        </nz-select>
      </div>
      <div class="form-group">
        <label for="pnaNo" class="textColor">P&A No.:</label>
        <div class="pna-search">
          <input
            type="text"
            nz-input
            placeholder=" Enter P&A number"
            formControlName="pnaNo"
          />
          <button nz-button nzType="primary">SEARCH</button>
        </div>
        <div
          *ngIf="
            searchForm.controls['pnaNo'].invalid &&
            searchForm.controls['pnaNo'].touched
          "
          class="error-message"
        >
          P&A No. must be a number.
        </div>
      </div>
    </form>
  </div>

  <nz-table
    class="StyleTable"
    #gridDataData
    nzBordered
    [nzData]="gridData"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageNumber"
    [nzShowSizeChanger]="true"
    [nzPageSizeOptions]="[10, 20, 50, 100]"
    (nzPageSizeChange)="onPageSizeChange($event)"
    (nzPageIndexChange)="onPageIndexChange($event)"
    [nzNoResult]="customNoDataMessage"
  >
    <thead>
      <tr>
        <th></th>
        <th>P&A No.</th>
        <th>CCN</th>
        <th>Purchasing Office</th>
        <th>Buyer</th>
        <th>Request By</th>
        <th>Status</th>
        <th>Create Date</th>
        <th>Last Updated Date</th>
        <th>Attachment</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of gridDataData.data; let i = index">
        <td class="action-col">
          <a (click)="onEditRequest(row)">
            <img
              src="../../../../assets/icons/edit.gif"
              alt="Edit P&A"
              width="14"
              height="14"
            />
          </a>
        </td>
        <td class="text-left">{{ row.pnaNo }}-{{ row.pnaYear }}</td>
        <td>{{ row.pnaCcn }}</td>
        <td>{{ row.pnaPurchasing }}</td>
        <td class="text-left">{{ row.pnaBuyerFullName | uppercase }}</td>
        <td class="text-left">{{ row.pnaRequestorFullName | uppercase }}</td>
        <td>{{ row.pnaStatus }}</td>
        <td>{{ row.pnaCreateDate | date : "dd-MMM-yy" }}</td>
        <td>{{ row.pnaUpdateDate | date : "dd-MMM-yy" }}</td>
        <td>
          <ng-container *ngIf="row.hasAttachment">
            <img
              src="../../../assets/attach_icon.gif"
              alt="Attachment Icon"
              title="Has Attachment"
            />
          </ng-container>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
